import React, { useState } from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import WorkerList from '../Components/Validation/WorkerList';

export default function ValidationWorkers() {
  const [actionMessage, setActionMessage] = useState<string | null>(null);

  const handleScale = async (count: number) => {
    try {
      const response = await fetch('/api/validation/queue/workers/scale', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ count }),
      });

      if (!response.ok) {
        throw new Error(`Scale failed: ${response.status}`);
      }

      setActionMessage(`Scaled to ${count} workers`);
      setTimeout(() => setActionMessage(null), 3000);
    } catch (err: any) {
      setActionMessage(err.message);
    }
  };

  const handleRestart = async (workerName: string) => {
    try {
      const response = await fetch('/api/validation/queue/workers/restart', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ worker_name: workerName }),
      });

      if (!response.ok) {
        throw new Error(`Restart failed: ${response.status}`);
      }

      setActionMessage(`Restarted ${workerName}`);
      setTimeout(() => setActionMessage(null), 3000);
    } catch (err: any) {
      setActionMessage(err.message);
    }
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          Workers
        </Typography>
      </Box>

      {actionMessage && (
        <Alert severity={actionMessage.includes('Scaled') || actionMessage.includes('Restarted') ? 'success' : 'error'} sx={{ mb: 2 }}>
          {actionMessage}
        </Alert>
      )}

      <WorkerList onScale={handleScale} onRestart={handleRestart} />
    </Box>
  );
}
